import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Form,
  Button,
  Modal,
  Spinner,
  InputGroup,
  Dropdown,
} from "react-bootstrap";

import { AiOutlineInfoCircle } from "react-icons/ai";
import { GoCheckCircleFill } from "react-icons/go";
import "../../../../src/TextFamily.css";
import "../PopUp.css";

import "../DeshBoard.css";
import UploadIcon from "../../../assests/upload-icon.png";

import AutocompleteSearchBox from "./AutoCompleteSearchBox";
import MarketPlaceIcon from "../../../assests/marketplace-logo.png"; // fallback if no API icon
import { Api } from "../../../services/httpService";
import { url, subscriptionKey } from "../../../constants";
import ProductDetailsModal from "./ProductDetailsModal";
import ProductUploadModal from "./ProductUploadModal";
import Loader from "../Loader";
function FinanceProductBrand({
  buyer,
  setBuyer,
  productBrand,
  setProductBrand,
  selectedProduct,
  setSelectedProduct,
  showModal,
  setShowModal,
}) {
  const [] = useState(false);
  const [expandAll, setExpandAll] = useState(false);
  const [query, setQuery] = useState("");
  const [productCategories, setProductCategories] = useState([]);
  const [logoIcon, setLogoIcon] = useState({}); // ✅ not null
  const [loading, setLoading] = useState(true);
  const merchantId = localStorage.getItem("_id");

  const getFile = async (item) => {
    const tokenHeader = localStorage.getItem("_token") || "";

    if (item?.logo?.id) {
      const logoId = item.logo.id;
      try {
        const fileRes = await fetch(`${url}/files/${logoId}`, {
          method: "GET",
          headers: {
            "Ocp-Apim-Subscription-Key": subscriptionKey,
            Authorization: tokenHeader,
          },
          redirect: "follow",
        });

        if (fileRes.ok && fileRes.body) {
          const blob = await fileRes.blob();
          const reader = new FileReader();

          reader.onloadend = () => {
            const base64data = reader.result;
            setLogoIcon((prev) => ({
              ...prev,
              [logoId]: base64data,
            }));
          };

          reader.readAsDataURL(blob);
        }
      } catch (err) {
        console.error(`Failed to fetch logo for platform ${logoId}:`, err);
      }
    }
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const response = await Api(
          "get",
          `/product/buyer_platforms?productCode=${buyer?.uniqueCode}&&merchantId=${merchantId}`
        );
        if (response && response.body) {
          // ✅ Transform API response into {title, products[]} format
          const categories = Object.keys(response.body).map((key) => ({
            title: key,
            products: response.body[key],
          }));

          setProductCategories(categories);

          // fetch logos
          categories.forEach((cat) => {
            cat.products.forEach((item) => getFile(item));
          });
        } else {
          console.warn("No Product found in response.");
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [showModal]);

  const handleProductClick = (product) => {
    setSelectedProduct(product);
  };

  const handleContinue = () => {
    if (selectedProduct) {
      setShowModal(true);
    } else {
      alert("Please select a product first!");
    }
  };

  const filterProducts = (products) => {
    return products.filter((p) =>
      p.name.toLowerCase().includes(query.toLowerCase())
    );
  };

  return (
    <div className="deshboard-content product-brand-content pb-0">
      <div className="dashboard-head">
        <div className="container">
          <div className="company-list-content mb-4">
            <div className="row align-items-end">
              <div className="col-12">
                <div className="breadcrumb-section mb-4">
                  <ul className="breadcrumb">
                    <li>Financing Solution</li>
                  </ul>
                </div>

                {/* Buyer Search */}
                <AutocompleteSearchBox
                  query={query}
                  setQuery={setQuery}
                  placeholder="Search Buyer..."
                  data={productCategories}
                  logoIcon={logoIcon}
                />

                {/* Buyer Note */}
                <div className="buyer-note mt-4">
                  <div className="buyer-note-centent d-flex p-3 align-items-start">
                    <span>
                      <AiOutlineInfoCircle />
                    </span>
                    <p className="m-0">
                      If you do business with multiple buyers, start with the
                      largest one. You can always add new buyer platforms later
                      at your convenience.
                    </p>
                  </div>
                </div>

                {productCategories.length > 0 && (
                  <div className="text-end mt-3">
                    <span
                      className="primary btn-link p-0"
                      style={{ cursor: "pointer" , color : "#0B84FE" }}
                      onClick={() => setExpandAll((prev) => !prev)}
                    >
                      {expandAll ? "Expand Less" : "Expand All"}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="company-info-box finance-product-section">
        <div className="container">
          {loading ? (
            <Loader />
          ) : (
            productCategories.map((category, catIndex) => {
              const filteredProducts = filterProducts(category.products);
              const visibleProducts =
                expandAll || filteredProducts.length <= 10
                  ? filteredProducts
                  : filteredProducts.slice(0, 10);

              if (filteredProducts.length === 0) return null;

              return (
                <div key={catIndex} className="f-product-box mb-4">
                  <div className="mb-3 f-product-heading d-flex align-items-center justify-content-between">
                    <h2>{category.title}</h2>
                  </div>

                  <ul className="b-product-list list-unstyled d-flex align-items-start flex-wrap">
                    {visibleProducts.map((product, index) => {
                      const isActive =
                        selectedProduct && selectedProduct.id === product.id;
                      const logoId = product?.logo?.id;
                      const base64data = logoId ? logoIcon[logoId] : null;
                      return (
                        <>
                          {product?.selected ? (
                            <li
                              className="mb-3 product-selected position-relative"
                              style={{ cursor: "pointer" }}
                            >
                              <div className="p-img-box d-inline-flex align-items-center px-3 py-3 justify-content-center mb-2">
                                <img
                                  src={base64data || MarketPlaceIcon }
                                  alt={product.name}
                                  style={{ width: 52 }}
                                />
                              </div>
                              <span className="check-green-icon position-absolute">
                                <GoCheckCircleFill />
                              </span>
                              <div className="b-product-name text-center">
                                {product.name}
                              </div>
                            </li>
                          ) : (
                            <li
                              key={index}
                              className={`mb-3  ${isActive ? "active" : ""} 
 `}
                              onClick={() => handleProductClick(product)}
                              style={{ cursor: "pointer" }}
                            >
                              <div className="p-img-box d-inline-flex align-items-center px-3 py-3 justify-content-center mb-2">
                                <img
                                  src={base64data || MarketPlaceIcon }
                                  alt={product.name}
                                  style={{ width: 52 }}
                                />
                              </div>
                              <div className="b-product-name text-center">
                                {product.name}
                              </div>
                            </li>
                          )}
                        </>
                      );
                    })}
                  </ul>
                </div>
              );
            })
          )}
        </div>
      </div>

      {/* Continue Button */}
      <div className="p-continue-btn position-fixed text-end w-100 py-3 px-4">
        <div className="container">
          <Button
            className={`cntu-btn ${selectedProduct ? "active" : ""}`}
            variant="primary"
            onClick={handleContinue}
          >
            Continue
          </Button>
        </div>
      </div>

      {/* Modal ERP present */}
      {showModal && selectedProduct?.erpPresent && (
        <ProductDetailsModal
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
          logoIcon={
            selectedProduct?.logo?.id
              ? logoIcon[selectedProduct?.logo?.id]
              : null
          }
          buyer={buyer}
          setBuyer={setBuyer}
          setProductBrand={setProductBrand}
          productBrand={productBrand}
          setShow={setShowModal}
          show={showModal}
          merchantId={merchantId}
        />
      )}

      {/* Modal ERP present not true*/}
      {showModal && !selectedProduct?.erpPresent && (
        <>
          <ProductUploadModal
            selectedProduct={selectedProduct}
            setSelectedProduct={setSelectedProduct}
            logoIcon={
              selectedProduct?.logo?.id
                ? logoIcon[selectedProduct?.logo?.id]
                : null
            }
            buyer={buyer}
            setBuyer={setBuyer}
            setProductBrand={setProductBrand}
            productBrand={productBrand}
            setShow={setShowModal}
            show={showModal}
            merchantId={merchantId}
          />
        </>
      )}
    </div>
  );
}

export default FinanceProductBrand;
